import {FilmConfig, Locale, Security} from '../types/initialiseDataFromBe'
import { getFilmConfigData, getFilterConfigData, getFormConfigData, getLocaleConfigData, getMemberConfigData, getNotificationConfigData, getSecurityConfigData, getShowtimeConfigData } from './config'

import { NestedPartial } from '@vista/omnichannel-components-domain'
import { OccConfig } from '@vista/omnichannel-components-ui'

export interface GetConfigDataProps {
    enablePropertyValidation?:boolean
    enableLoadingIndicator?: boolean
    locale?:NestedPartial<Locale>
    security?: NestedPartial<Security>
    film?: NestedPartial<FilmConfig>
}

export function getConfigData(props:GetConfigDataProps):OccConfig {
    const {locale, film, security} = props

    return {
        /**
     * Determines whether or not component properties will be validated.
     * Should be enabled during development or debugging, and disabled in production for performance.
     */
    enablePropertyValidation: true,
    /**
     * Determines whether or not skeleton loading indicators will be shown for components.
     */
    enableSkeletonLoadingIndicators: true,
    /**
     * Film configuration options.
     */
    film: getFilmConfigData(film),
    /**
     * Filter configuration options.
     */
    filter: getFilterConfigData(),
    /**
     * Form configuration options.
     */
    form: getFormConfigData(),
    /**
     * Locale configuration options used by OccI18n for localised formatting.
     */
    locale: getLocaleConfigData(locale),
    /**
     * Member configuration options.
     */
    member: getMemberConfigData(),
    /**
     * Notification configuration options.
     */
    notification: getNotificationConfigData(),
    /**
     * Security configuration options.
     */
    security: getSecurityConfigData({security}),
    /**
     * Showtime configuration options.
     */
    showtime: getShowtimeConfigData()
    }
}